/* eslint import-x/no-duplicates: "off"
 ------------
 clashes with @typescript-eslint/consistent-type-imports
 */
import {
  TimeSeries,
  TimeSeriesS,
} from './history.ts';
import type {
  AssetTypeId,
} from './assets.ts';
import {
  Assets,
} from './assets.ts';

export type AccountHistory = Array<{year: number; assets: Assets}>;

export function toTimeSeries(ah: AccountHistory): TimeSeriesS<number> {
  const types: AssetTypeId[] = [
    ...new Set(
      ah.flatMap(
        aa => [...aa.assets.keys],
      ),
    ),
  ].sort();

  /* eslint @typescript-eslint/require-array-sort-compare: "off" */
  const years: number[] = [
    ...new Set(ah.map(aa => aa.year)),
  ].sort();

  return new TimeSeriesS<number>(types.map(t => new TimeSeries<number>(
    t.toString(),
    years.map(y => ({
      year: y,
      value: ah.find(aa => aa.year === y)?.assets?.balance(t) ?? 0,
    })),
  )));
}

export function padToEndYear(ah: AccountHistory, maxYear: number): AccountHistory {
  const maxExistingYear = Math.max(...ah.map(d => d.year));

  const padded = [...ah];

  for (let year = maxExistingYear; year <= maxYear; ++year) {
    padded.push({year, assets: new Assets()});
  }

  return padded;
}
